// Loaded from frontend/.env at dev/build time (Vue CLI only reads env in project root)

function envString(name, fallback = '') {
  return String(process.env[name] || fallback).trim().replace(/^['"]|['"]$/g, '')
}

export const API_KEY = envString('VUE_APP_TMDB_API_KEY')
export const tmdburl = envString('VUE_APP_TMDB_API_URL', 'https://api.themoviedb.org/3/')
export const imgTmdbUrl = envString('VUE_APP_TMDB_IMG_URL', 'https://image.tmdb.org/t/p/original')

